import React, { useMemo } from "react";
import styles from "./ContestGifts.module.css";
//import { useBackButton } from "../../hooks/useBackButton";

interface ContestGiftsProps {
  gifts: any[];
  onClose: () => void;
  isOpen: boolean;
}

export const ContestGifts: React.FC<ContestGiftsProps> = ({
  gifts,
  //onClose,
  isOpen,
}) => {
  // useBackButton({
  //   isOpen,
  //   onBack: onClose,
  // });

  if (!isOpen) return null;

  const processedGifts = useMemo(() => {
    if (!gifts) return [];

    const sorted = [...gifts].sort((a, b) => a.id - b.id);
    const processed = sorted.map((gift, index) => ({
      ...gift,
      name: `${index + 1}. ${gift.name.replace(/^\d+\.\s*/, "")}`,
    }));
    return processed;
  }, [gifts]);

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h1 className={styles.title}>Призовой фонд</h1>
        </div>

        <div className={styles.content}>
          <div className={styles.giftsList}>
            {processedGifts?.map((gift, index) => (
              <div key={gift.id}>
                <div className={styles.giftItem}>
                  <div className={styles.giftImage}>
                    <img
                      src={gift.photo_url}
                      alt={gift.name}
                      className={styles.giftPhoto}
                    />
                  </div>
                  <div className={styles.giftInfo}>
                    <h3 className={styles.giftName}>{gift.name}</h3>
                    {gift.qty > 1 && (
                      <div className={styles.giftQuantity}>
                        Количество: {gift.qty} шт.
                      </div>
                    )}
                  </div>
                </div>
                {index < processedGifts.length - 1 && (
                  <div className={styles.separator} />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
